<template>
  <div>
    <label class="text-left block">
      <slot></slot>
    </label>
    <select v-if="!disabled && (options instanceof Array)" class="w-full rounded-md !shadow w-full !border
      font-normal
      bg-white
      border-gray-300
      outline-none
      text-md
      text-black
      px-3
      py-2
      placeholder-gray-600"
      v-model="formValues"
      :required="required"  
      :disabled="disabled" 
      @blur="blurEvent()"
    >
      <option v-for="item in arrayOptions" :key="item.label" :value="item.value">
        {{ item.label }}
      </option>
    </select>

    <select v-if="!disabled && !(options instanceof Array)" class="w-full rounded-md !shadow w-full !border
      bg-white
      border-gray-300
      outline-none
      text-md
      text-black
      px-3
      py-2
      placeholder-gray-600" 
      v-model="formValues"
      :required="required"  
      :disabled="disabled" 
      @blur="blurEvent()"
      >
      <!--option value="" selected disabled hidden>Select gender:</option-->
      <option v-for="(val, key) in options" :key="key" :value="key">
        {{ val }}
      </option>
    </select>

    <select v-if="disabled" class="w-full rounded-md !shadow w-full !border
      font-normal
      bg-gray-100
      border-gray-300
      outline-none
      text-md
      text-black
      px-3
      py-2
      placeholder-gray-600
      cursor-not-allowed" 
      :required="required"  
      :disabled="disabled"
      v-model="formValues"
      @blur="blurEvent()">
      <option :selected="true" :value="formValues">
        {{ options[formValues] }}
      </option>
    </select>
    <InputError 
      :label="errorLabel" 
      :condition="errorCondition && required && edited"
    />
    <!-- <div>Default Data: {{ defaultValue }}</div>
    <div>model: {{ model }}</div>
    <div>Options: {{ options }}</div>
    <div>ArrayOptions: {{ arrayOptions }}</div> -->
  </div>
</template>

<script>

import InputError from './InputError.vue';

export default {
  props: {
    disabled: Boolean,
    options: undefined,
    value: undefined,
    required: Boolean,
    defaultValue: undefined,
    errorLabel: String,
    errorCondition: Boolean,
    label: undefined,
    val: undefined,
  },
  components: {
    InputError
  },
  data() {
    return {
      arrayOptions: [],
      edited: false,

      formValues: undefined
    }
  },
  methods: {
    getOptions() {
      if (this.val !== undefined && this.label !== undefined) {
        let toReturn = []
        for (const option of this.options) {
          toReturn.push({'value': option[this.val], 'label': option[this.label]})
        }
        return toReturn
      }
      else if (this.label !== undefined) {
        let toReturn = []
        for (const option of this.options) {
          toReturn.push({'value': option, 'label': option[this.label]})
        }
        return toReturn
      }
      else {
        let toReturn = []
        for (const option of this.options) {
          if (option instanceof Object) {
            toReturn.push({'value': option.value, 'label': option.label })
          }
          else {
            toReturn.push({'value': option, 'label': option })
          }
        }
        return toReturn
      }
    },
    blurEvent() {
      this.edited = true
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  mounted() {
    if (this.options instanceof Array) {
      if (this.options.length > 0) {
        this.arrayOptions = this.getOptions()
      }
      else {
        this.arrayOptions = []
      }
    }
    if (this.defaultValue) {
      this.formValues = this.defaultValue
    }
    else if (this.value) {
      this.formValues = this.value
    }
  },
  watch: {
    options() {
      if (this.options instanceof Array) {
        if (this.options.length > 0) {
          this.arrayOptions = this.getOptions()
        }
        else {
          this.arrayOptions = []
        }
      }
    },
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
    }
  }
}
</script>
